import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetInboundCampaignMessagingDataQuery } from "../store/slices/widgetsSlice.ts";
import SearchIcon from "../../assets/icons/search.svg2";
import {
  faAngleDown,
  faAngleUp,
  faPen,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import MyModal from "../Common/MyModal";
import { Link } from "react-router-dom";
import MyPagination from "../Common/MyPagination";
import Report from "../Reporting/RealtimeReporting/Report.jsx";

const columnOptions = [
  { value: "Date", label: "Date" },
  { value: "Channel", label: "Channel" },
  { value: "From", label: "From" },
  { value: "To", label: "To" },
  { value: "Handlers", label: "Handlers" },
];

export default function InboundCampaignMessaging({ showTransactions = true }) {
  const [inputText, setInputText] = useState("");
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState("asc");
  const [pagination, setPagination] = useState({ offset: 0, limit: 12 });
  const [columnsToShow, setColumnsToShow] = useState(
    localStorage.getItem("InboundMessagingOverviewColumns")
      ? JSON.parse(localStorage.getItem("InboundMessagingOverviewColumns"))
      : ["report", "Date", "Channel", "From", "To", "Handlers"]
  );

  const { data = { summary: [], total: 0 } } =
    useGetInboundCampaignMessagingDataQuery({ search, order, ...pagination });

  // debounce
  useEffect(() => {
    const timeOut = setTimeout(() => {
      setSearch(inputText);
    }, 300);

    return () => {
      clearTimeout(timeOut);
    };
  }, [inputText]);

  return (
    <>
      <div className="d-flex justify-content-end mb-3 gap-3">
        <div className="position-relative  w-25">
          <input
            placeholder="Search"
            className="form-control"
            style={{ height: 38, paddingRight: 40 }}
            type="text"
            value={inputText}
            onChange={(e) => {
              setInputText(e.target.value);
            }}
          />
          <SearchIcon
            width={30}
            heigth={30}
            className="white bg-colored position-absolute top-50 end-0 translate-middle rounded-circle p-2"
            style={{ marginRight: -10 }}
          />
        </div>
        <DropdownButton
          id="show-colums-dropdown"
          title="Show columns"
          variant="colored"
          autoClose="outside"
          align="end"
          className="h-100 rounded-3"
        >
          {columnOptions.map((c) => (
            <Dropdown.Item as="div" key={c.value}>
              <Form.Check
                checked={columnsToShow.includes(c.value)}
                label={c.label}
                id={`${c.value}-checkbox`}
                onChange={() => {
                  setColumnsToShow((p) => {
                    let newColumns;
                    if (p.includes(c.value)) {
                      newColumns = p.filter((pc) => pc !== c.value);
                    } else {
                      newColumns = [...p, c.value];
                    }
                    localStorage.setItem(
                      "InboundMessagingOverviewColumns",
                      JSON.stringify(newColumns)
                    );
                    return newColumns;
                  });
                }}
              />
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </div>
      <div>
        <Table striped bordered hover>
          <thead>
            <tr>
              {columnsToShow.includes("Date") && (
                <th>
                  <button
                    className="btn btn-link p-0"
                    type="button"
                    onClick={() => {
                      setOrder((p) => (p === "asc" ? "desc" : "asc"));
                    }}
                  >
                    Date
                  </button>

                  <FontAwesomeIcon
                    className="ms-2"
                    icon={order === "asc" ? faAngleUp : faAngleDown}
                  />
                </th>
              )}
              {columnsToShow.includes("Channel") && <th>Channel</th>}
              {columnsToShow.includes("From") && <th>From</th>}
              {columnsToShow.includes("To") && <th>to</th>}
              {columnsToShow.includes("Handlers") && <th>Handlers</th>}
            </tr>
          </thead>
          <tbody>
            {data.summary.map((item, i) => (
              <tr key={i}>
                {columnsToShow.includes("Date") && (
                  <td>
                    {/* <MyModal
                    size="lg"
                    label={item.id}
                    buttonClassName="btn btn-link"
                    modalClassName="bg-purple-gradient"
                  >
                    <div>
                      {item.channel === "email" && (
                        <div>
                          <h3>Subject</h3>
                          {item.subject}
                        </div>
                      )}
                      <div>
                        <h3>Content</h3>
                        {item.content}
                      </div>
                    </div>
                  </MyModal> */}
                    {new Date(item.at).toLocaleString()}
                  </td>
                )}
                {columnsToShow.includes("Channel") && <td>{item.channel}</td>}
                {columnsToShow.includes("From") && <td>{item.from}</td>}
                {columnsToShow.includes("To") && <td>{item.inbound}</td>}

                {columnsToShow.includes("Handlers") && (
                  <td>
                    {item.hits.map((hit, idx) => (
                      <div key={idx}>
                        <div>
                          {hit.From}{" "}
                          {showTransactions && (
                            <Link
                              to={`/reporting/realtime/inbound?inboundUUID=${hit.HandlerUuid}&startDate=${item.at}`}
                              className="btn btn-link p-0"
                              title="View inbound messaging transactions"
                            >
                              <FontAwesomeIcon icon={faTable} />
                            </Link>
                          )}
                        </div>
                      </div>
                    ))}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
        <MyPagination
          total={data.total}
          onPaginate={(page, perPage) => {
            setPagination({ offset: page * pagination.limit, limit: perPage });
          }}
        />
        {data.total === 0 && (
          <div className="alert alert-warning text-center">Nothing to show</div>
        )}
      </div>
    </>
  );
}
